module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchend": ""
    },
    on: {
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.handleTouchEnd($event)
      }
    }
  }, [_c('dof-overlay', _vm._b({
    ref: "overlay",
    attrs: {
      "show": _vm.overlayShow,
      "canAutoClose": _vm.isOverLayClickHide,
      "data-evt-dofOverlayBodyClicked": ""
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicking
    }
  }, 'dof-overlay', _vm.overlayCfg, false))], 1), _vm._v(" "), (_vm.show_) ? _c('div', {
    ref: "dof-popup",
    staticClass: " weex-ct weex-div",
    class: ['dof-popup', _vm.pos],
    style: (_vm._px2rem(_vm.padStyle, 75)),
    attrs: {
      "height": _vm._height,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return (function () {})($event)
      }
    }
  }, [_vm._t("default", null, {}), _vm._v(" "), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticClass: "btnGap weex-ct weex-div",
    staticStyle: {
      "height": "0.26667rem"
    },
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticClass: "midea-actionsheet-bottom weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.button), function(btn, index) {
    return _c('p', {
      key: index,
      staticClass: " weex-el weex-text",
      class: ['midea-actionsheet-btn'],
      style: ({
        color: btn.hasOwnProperty('textColor') ? btn.textColor : _vm._isColmo ? 'rgba(255,255,255,0.80)' : index === 0 && !_vm._isDiablo ? '#616C73' : index === 0 && _vm._isDiablo ? '#797c7e' : '#00A4F2'
      }),
      attrs: {
        "weex-type": "text",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          _vm.actionsheetBtnClick(index, btn.hasOwnProperty('text') ? btn.text : btn)
        }
      }
    }, [_vm._v(_vm._s(btn.hasOwnProperty('text') ? btn.text : btn))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    style: ({
      height: _vm._px2rem(_vm.show && _vm.isipx ? _vm.sageHeight + 'px' : '0px', 75),
      backgroundColor: _vm.safeAreaBgColor ? _vm.safeAreaBgColor : _vm._isColmo ? '#151617' : _vm.padStyle.backgroundColor
    }),
    attrs: {
      "weex-type": "div"
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fa0ab532", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa0ab532","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-popup/index.vue
// module id = 670
// module chunks = 0 1